module.exports = __webpack_public_path__ + "img/28.b80bc417.jpg";